window.wf_icon = (iconName)=>{
	if (iconName.includes('svg-icon')){
		const svgIconName = iconName.replace('svg-icon-', '');
		return `<span class="wf-icon"><svg fill="currentColor" height="24"><use xlink:href="/wp-content/webfactory/icons.svg#${svgIconName}" /></svg></span>`;
	}
	return `<span class="wf-icon ${iconName}"></span>`;
}
